import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@getnuvo/importer-react'

export const messagePopup: ThemeAPI['messagePopup'] = {
  root: {
    backgroundColor: theme.colors.white,
  },
  title: {
    color: theme.colors.grey1000,
  },
  description: {
    color: theme.colors.grey700,
  },
  warnIcon: {
    stroke: theme.colors.warningBackgroundSolid,
  },
  closeIcon: {
    stroke: theme.colors.grey800,
  },
}
